import React from 'react';
import PropTypes from 'prop-types';

import { Day } from './Day';

export const Month = ({
    days,
    mobile,
    monthNo,
    monthText = '',
    weekdaysInitials,
    onDatesClick,
    datesOptions,
    setCalendarOpen,
}) => {
    const WEEKDAYS = [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
    ];

    const [monthOnly, year] = monthText.split(' ');

    // if (days.length < 28) {
    //     return null;
    // }

    const firstDayOfMonth = days[0];
    const firstDayOfMonthString = new Date(
        firstDayOfMonth?.date
    ).toLocaleDateString('en-us', {
        weekday: 'long',
    });

    const daysOutOfMonth = WEEKDAYS.indexOf(firstDayOfMonthString);

    // Add days out of month
    if (daysOutOfMonth > 0) {
        days = new Array(daysOutOfMonth).fill('').concat(days);
    }

    const renderRows = () => {
        const rows = [];
        let cells = [];

        for (let i = 0; i < days.length; i++) {
            const day = days[i];
            const nextDay = i + 1 < days.length ? days[i + 1] : undefined;

            if (i === 0 || i % 7 !== 0) {
                if (day === '') {
                    cells.push(
                        <Day
                            day={day}
                            key={`out-of-month-day-${year}-${i}`}
                            nextDay={nextDay}
                            mobile={mobile}
                            onDatesClick={onDatesClick}
                            datesOptions={datesOptions}
                            setCalendarOpen={setCalendarOpen}
                        />
                    );
                } else {
                    const dayOfMonth = day.date.split('-')[2];

                    cells.push(
                        <Day
                            day={day}
                            dayOfMonth={dayOfMonth}
                            key={`day-${day?.date}`}
                            nextDay={nextDay}
                            mobile={mobile}
                            onDatesClick={onDatesClick}
                            datesOptions={datesOptions}
                            setCalendarOpen={setCalendarOpen}
                        />
                    );
                }
            } else {
                rows.push(cells);
                cells = [];

                if (day === '') {
                    cells.push(
                        <Day
                            day={day}
                            key={`out-of-month-day-${year}-${i}`}
                            nextDay={nextDay}
                            mobile={mobile}
                            onDatesClick={onDatesClick}
                            datesOptions={datesOptions}
                            setCalendarOpen={setCalendarOpen}
                        />
                    );
                } else {
                    const dayOfMonth = day.date.split('-')[2];
                    cells.push(
                        <Day
                            day={day}
                            dayOfMonth={dayOfMonth}
                            key={`day-${day?.date}`}
                            nextDay={nextDay}
                            mobile={mobile}
                            onDatesClick={onDatesClick}
                            datesOptions={datesOptions}
                            setCalendarOpen={setCalendarOpen}
                        />
                    );
                }
            }

            if (i === days.length - 1) {
                rows.push(cells);
            }
        }

        // Ensure at least 6 rows
        while (rows.length < 6) {
            rows.push(
                <tr
                    key={`extra-row-${rows.length}-${year}-${monthNo}`}
                    className="extra-calendar-row"
                >
                    {Array(7).fill(<td className="empty-day"></td>)}
                </tr>
            );
        }

        return rows?.map((row, index) => (
            <tr key={`week-row-${index}-${year}-${monthNo}`}>{row}</tr>
        ));
    };

    return (
        <div className="iHotelWebAppCalendarMonth month-wrapper iHcM_1 iHcMs">
            {mobile ? (
                <div className="month-title month-title--mobile">
                    <span>{monthOnly}</span>
                    <span>{year}</span>
                </div>
            ) : (
                <span className="month-title">{monthText}</span>
            )}
            <table className="iHotelWebAppCalendarTable">
                <thead>
                    <tr>
                        {weekdaysInitials?.map((day, index) => {
                            return (
                                <th
                                    className="iHotelWebAppCalendarDaysTitle"
                                    key={index}
                                >
                                    {day}
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody style2="border-bottom: none !important; ">
                    {renderRows()}
                </tbody>
            </table>
        </div>
    );
};

Month.propTypes = {
    days: PropTypes.arrayOf(
        PropTypes.shape({
            date: PropTypes.string,
            status: PropTypes.string,
            price: PropTypes.number,
            currency: PropTypes.string,
        })
    ),
    mobile: PropTypes.bool,
    monthNo: PropTypes.number,
    monthText: PropTypes.string,
    weekdaysInitials: PropTypes.arrayOf(PropTypes.string),
    onDatesClick: PropTypes.func,
    setCalendarOpen: PropTypes.func,
    datesOptions: PropTypes.object,
};

Month.defaultProps = {
    days: [],
    weekdaysInitials: [],
};
